var map = {
	"./game-com.svg": 6803,
	"./icon-arrow-left.svg": 2436,
	"./icon-checkmark.svg": 8230,
	"./icon-exit.svg": 455,
	"./icon-exit2.svg": 4887,
	"./icon-home.svg": 5746,
	"./icon-ok.svg": 7125,
	"./icon-ranking.svg": 1283,
	"./icon-refer.svg": 6167,
	"./icon-suprise.svg": 2702,
	"./icon-task.svg": 3316,
	"./icon-tg.svg": 836,
	"./icon-x.svg": 5661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;